import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AddVendorQuoteDialogData {
  materialName: string;
  vendorName: string;
  qty: number;
  unit: string;
  /** What the line costs per unit now. */
  unitCost: number;
  /** Quotes that already list this material and can be picked. */
  quoteCount: number;
  /** Lowest unit price among those quotes, or null when there are none. */
  lowestPrice: number | null;
  /** The quote the line uses now, when this is a Change rather than an Add. */
  currentQuote?: string | null;
}

export type AddVendorQuoteChoice = 'select' | 'upload';

/**
 * Add Vendor Quote — the first step: pick an existing quote, or upload a new one.
 * Clicking a card answers the question; there is no separate Continue.
 */
@Component({
  selector: 'app-add-vendor-quote-dialog',
  templateUrl: './add-vendor-quote-dialog.component.html',
  styleUrls: ['./add-vendor-quote-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AddVendorQuoteDialogComponent {
  /** Saving per unit against the line's price now, when the lowest quote beats it. */
  readonly lowestSaves: number;

  constructor(
    private dialogRef: MatDialogRef<AddVendorQuoteDialogComponent, AddVendorQuoteChoice | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: AddVendorQuoteDialogData,
  ) {
    this.lowestSaves = data.lowestPrice != null ? Math.max(0, data.unitCost - data.lowestPrice) : 0;
  }

  choose(choice: AddVendorQuoteChoice): void {
    if (choice === 'select' && !this.data.quoteCount) return;
    this.dialogRef.close(choice);
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }
}
